import { IEvent } from "@Interfaces";
import { isTimePassed } from "@Utils";
import { LISTING_TYPES } from "repoV2/constants/listing";
import { parseDateTime } from "@Utils/parseDateTime";

const errorMsg =
    "This session has already started. You can only attend the remaining session(s).";

/**
 * to check if there is any already started event in the selected offering
 * @param eventData event data object having type and slots
 * @param selectedSlots selected slots of ther offering
 */
export const handleEventStarted = ({
    eventData,
    selectedSlots,
}: {
    eventData: IEvent.IEventData;
    selectedSlots?: Array<string>;
}) => {
    const eventType = eventData.type;
    const slots = eventData.slots || [];

    switch (eventType) {
        case LISTING_TYPES.WORKSHOPS: {
            if (
                slots.some(slot =>
                    isTimePassed(parseDateTime(slot.start_time).valueOf())
                )
            )
                alert(errorMsg);
            break;
        }
        case LISTING_TYPES.APPOINTMENTS: {
            if (
                slots.some(
                    slot =>
                        selectedSlots?.find(
                            selectedSlotUuid => selectedSlotUuid === slot.uuid
                        ) &&
                        isTimePassed(parseDateTime(slot.start_time).valueOf())
                )
            )
                alert(errorMsg);
            break;
        }

        default:
            break;
    }
};
